module.exports = __webpack_public_path__ + "static/media/2022-2023_TMEA_REGION_20_MARIACHI_DIRECTORS_HANDBOOK_AMENDED.dc060989.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/mariachi/2022-2023_TMEA_REGION_20_MARIACHI_DIRECTORS_HANDBOOK_AMENDED.pdf
// module id = 209
// module chunks = 0